import { render, staticRenderFns } from "./BookModal.vue?vue&type=template&id=25fd588e&"
import script from "./BookModal.vue?vue&type=script&lang=js&"
export * from "./BookModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports